import React from 'react';
import { Box, Container, Typography, Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import StoreButtons from '../StoreButtons';

const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      id="about"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
        color: 'white',
        pt: 8,
        pb: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Typography
                component="h1"
                variant="h2"
                fontWeight="bold"
                mb={3}
                sx={{
                  fontSize: { xs: '2.5rem', md: '3.5rem' },
                  textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
                }}
              >
                ДокМедЧат
              </Typography>
              <Typography
                variant="h4"
                mb={3}
                sx={{
                  fontWeight: 400,
                  lineHeight: 1.4,
                  fontSize: { xs: '1.25rem', md: '1.5rem' },
                }}
              >
                Защищенная платформа для общения медработников и пациентов
              </Typography>
              <Typography
                variant="h6"
                paragraph
                mb={3}
                sx={{
                  opacity: 0.9,
                  maxWidth: '600px',
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  fontWeight: 400,
                }}
              >
                Безопасная и конфиденциальная коммуникация между врачами, пациентами и их родственниками с защитой персональных данных.
              </Typography>
              <StoreButtons />
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <Box
                component="img"
                src="/images/docmedbg.png"
                alt="ДокМедЧат приложение"
                sx={{
                  maxWidth: '100%',
                  height: 'auto',
                  borderRadius: '12px',
                  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
                  transform: isMobile ? 'none' : 'perspective(1000px) rotateY(-10deg)',
                  transition: 'transform 0.5s ease',
                  '&:hover': {
                    transform: isMobile ? 'none' : 'perspective(1000px) rotateY(0deg)',
                  },
                }}
              />
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection; 